import React, { useState, useEffect } from 'react';
import { useGetAll } from '../hooks/AccountStatmentHook';
import {
  KTSVG,
  SimpleAlert,
  LoadingGrid,
  formatDateMonth,
  formatPriceMejorado,
} from '../../../../../_mexablock/helpers';
import {
  downloadExcel,
  downloadPDF,
  parseAxiosError,
} from '../../../../service/reportes/AccountStatment';
import { TableList } from '../../../../../_mexablock/helpers/components/TableList';
import { Filter } from '../../activaciones/_modals/Filter';

let fechaActual = new Date();
let fecha_inicio_init = new Date(
  fechaActual.getFullYear(),
  fechaActual.getMonth() - 1,
  1
);
let fecha_fin_init = new Date();

const View: React.FC = () => {
  const [loadingView, setloadingView] = useState(true);
  const [initFilterValues, setInitFilterValues] = useState({
    codeAccount: '',
    init_date: '',
    end_date: '',
    filter: 0,
  });
  const [reloadGrid, setReloadGrid] = useState(Math.random() * 40);
  const { data, loadingRequest } = useGetAll(reloadGrid, initFilterValues);
  const [loadingDownload, setloadingDownload] = useState<boolean>(false);
  const [loadingDownloadExcel, setloadingDownloadExcel] =
    useState<boolean>(false);

  useEffect(() => {
    if (data.length) {
      setloadingDownload(false);
      setloadingDownloadExcel(false);
    } else {
      setloadingDownload(true);
      setloadingDownloadExcel(true);
    }
  }, [data]);

  useEffect(() => {
    if (loadingRequest > 0) {
      setloadingView(false);
    }
  }, [loadingRequest]);

  const handleFilter = (values: any) => {
    setInitFilterValues(values);
  };
  const handleFilterClean = () => {
    setInitFilterValues({
      codeAccount: '',
      init_date: '',
      end_date: '',
      filter: 0,
    });
  };

  const columns: any = [
    {
      id: 'createdAt',
      name: <div className="fw-bolder text-muted me-5">Fecha</div>,
      selector: (row: any) => formatDateMonth(row.createdAt),
      sortable: true,
    },

    {
      id: 'iccid',
      name: <div className="fw-bolder text-muted me-5">ICCID</div>,
      selector: (row: any) => formatedOperation(row.operationType, row).iccid,
      sortable: true,
    },

    {
      id: 'cliente',
      name: <div className="fw-bolder text-muted me-5">Cliente</div>,
      selector: (row: any) => formatedOperation(row.operationType, row).cliente,
      sortable: true,
    },

    {
      id: 'operationType',
      name: <div className="fw-bolder text-muted me-5">Operación</div>,
      selector: (row: any) => row.operationType,

      sortable: true,
    },

    {
      id: 'monto',
      name: <div className="fw-bolder text-muted me-5">Monto</div>,
      selector: (row: any) => formatPriceMejorado(row.amount, 'es-MX', 'MXN'),

      sortable: true,
    },

    {
      id: 'usuario',
      name: <div className="fw-bolder text-muted me-5">Usuario</div>,
      selector: (row: any) => formatedOperation(row.operationType, row).usuario,
      sortable: true,
    },
  ];

  const handleDownloadPDF = () => {
    setloadingDownload(true);
    setTimeout(() => {
      downloadPDF(initFilterValues)
        .then(() => {
          setloadingDownload(false);
        })
        .catch(async (error) => {
          setloadingDownload(false);
          const message = await parseAxiosError(error);
          SimpleAlert(message, 4000, 'error');
        });
    }, 2000);
  };

  const handleDownloadExcel = () => {
    setloadingDownloadExcel(true);
    setTimeout(() => {
      downloadExcel(initFilterValues)
        .then(() => {
          setloadingDownloadExcel(false);
        })
        .catch(async (error) => {
          setloadingDownloadExcel(false);
          const message = await parseAxiosError(error);
          SimpleAlert(message, 4000, 'error');
        });
    }, 2000);
  };

  const formatedOperation = (typeOperation: string, item: any) => {
    let cliente = '';
    let usuario = '';
    let iccid = '';

    switch (typeOperation) {
      case 'Portabilidad':
        cliente =
          `${item.aditionalInfo?.portability?.customer?.first_name ?? ''} ${
            item.aditionalInfo?.portability?.customer?.father_last_name ?? ''
          }`.trim() || '';
        usuario =
          `${item.aditionalInfo?.portability?.user?.first_name ?? ''} ${
            item.aditionalInfo?.portability?.user?.father_last_name ?? ''
          }`.trim() || '';
        iccid = item.aditionalInfo?.portability?.iccid || '';
        break;

      case 'Activacion':
        cliente =
          `${item.aditionalInfo?.activation?.customer?.first_name ?? ''} ${
            item.aditionalInfo?.activation?.customer?.father_last_name ?? ''
          }`.trim() || '';
        usuario =
          `${item.aditionalInfo?.activation?.userCreate?.first_name ?? ''} ${
            item.aditionalInfo?.activation?.userCreate?.father_last_name ?? ''
          }`.trim() || '';
        iccid = item.aditionalInfo?.activation?.identifier_value || '';
        break;

      case 'Recarga':
        cliente =
          `${item.aditionalInfo?.recharge?.customer?.first_name ?? ''} ${
            item.aditionalInfo?.recharge?.customer?.father_last_name ?? ''
          }`.trim() || '';
        usuario =
          `${item.aditionalInfo?.recharge?.userCreate?.first_name ?? ''} ${
            item.aditionalInfo?.recharge?.userCreate?.father_last_name ?? ''
          }`.trim() || '';
        iccid = item.aditionalInfo?.recharge?.customer?.iccid || '';
        break;

      default:
        cliente = '';
        usuario = '';
        iccid = '';
    }
    return { cliente, usuario, iccid };
  };

  return (
    <>
      <div className="row gy-5 g-xl-8">
        <div className="col-xl-12">
          <div className={`card card-xxl-stretch mb-5 mb-xl-12`}>
            <div className="card-header border-0 pt-5">
              <Filter
                initFilterValues={initFilterValues}
                onCleanFilter={handleFilterClean}
                onSearchFilter={handleFilter}
                showFilterCode={true}
              />
              <div className="card-toolbar">
                <div className="d-flex rounded mt-3">
                  <button
                    className="btn btn-sm btn-light-success"
                    disabled={loadingDownloadExcel}
                    onClick={() => handleDownloadExcel()}
                  >
                    {loadingDownloadExcel && data.length ? (
                      <span
                        className="indicator-progress"
                        style={{ display: 'block' }}
                      >
                        Descargando...
                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                      </span>
                    ) : (
                      <>
                        <KTSVG
                          path="/media/icons/duotune/files/fil029.svg"
                          className="svg-icon-5 svg-icon-gray-500 me-1"
                        />
                        Descargar
                      </>
                    )}
                  </button>

                  <button
                    className="btn btn-sm btn-light-danger ms-5"
                    disabled={loadingDownload}
                    onClick={handleDownloadPDF}
                  >
                    {loadingDownload && data.length ? (
                      <span
                        className="indicator-progress"
                        style={{ display: 'block' }}
                      >
                        Descargando...
                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                      </span>
                    ) : (
                      <>
                        <KTSVG
                          path="/media/icons/duotune/files/fil030.svg"
                          className="svg-icon-5 svg-icon-gray-500 me-1"
                        />
                        Descargar
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
            {loadingView ? (
              <LoadingGrid text="Cargando..."></LoadingGrid>
            ) : (
              <TableList data={data} columns={columns}></TableList>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export { View };
